import { Component, inject, signal, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { GlobalButtonComponent, MenuItemComponent } from 'declarabid-library';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { UsersService } from '../../../features/users/services/users.service';
import { AuthService } from '../../../features/auth/services/auth.service';
import { UserRole } from '../../../core/models/auth.model';
import { Popover, PopoverModule } from 'primeng/popover';
import { OverlayNotificationsComponent } from '../overlay-notifications/overlay-notifications.component';
import { I18nService } from '../../../core/services/i18n.service';
import { NAVIGATION_BAR_TRANSLATIONS } from '../../../core/translations/navigation-bar.translations';
import { LanguageSelectorComponent } from "../language-selector/language-selector.component";
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-navigation-bar',
    imports: [
        RouterModule,
        CommonModule,
        GlobalButtonComponent,
        MenuItemComponent,
        AvatarModule,
        AvatarGroupModule,
        MenuModule,
        ButtonModule,
        DrawerModule,
        PopoverModule,
        OverlayNotificationsComponent,
        LanguageSelectorComponent
    ],
    templateUrl: './navigation-bar.component.html',
    styleUrl: './navigation-bar.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class NavigationBarComponent implements OnInit {
  @ViewChild('op') Popover!: Popover;

  public readonly _usersService = inject(UsersService).currentUser();
  readonly router = inject(Router);
  private readonly _authService = inject(AuthService);
  private readonly _i18nService = inject(I18nService);

  // Estado
  public sidebarVisible: boolean = false;
  public itemsOptions: MenuItem[] | undefined;
  options: MenuItem[] = [];
  public routeUser = inject(UsersService).userRoutes();
  public currentUserRole = signal<UserRole | undefined>(undefined);
  readonly UserRole = UserRole;

  public onHide() {
    document.body.classList.remove('no-scroll');
  }

  get adminRoute(): Routes {
    if(this.router.url.includes('home')){
      return 'home';
    }else if(this.router.url.includes('templates')){
      return 'templates';
    }else if(this.router.url.includes('institutions')){
      return 'institutions';
    }else if(this.router.url.includes('users')){
      return 'users';
    }else if(this.router.url.includes('projects')){
      return 'projects';
    }else if(this.router.url.includes('report')){
      return 'report';
    }else{
      return 'home';
    }
  }


  goToProfile() {
    if (this.currentUserRole() === UserRole.teacher) {
      this.router.navigate(['/teacher/profile']);
    } else if (this.currentUserRole() === UserRole.director) {
      this.router.navigate(['/director/profile']);
    }else if (this.currentUserRole() === UserRole.admin) {
      this.router.navigate(['/admin/profile']);
    }else if (this.currentUserRole() === UserRole.leader) {
      this.router.navigate(['/leader/profile']);
    }
  }

  ngOnInit(): void {
    // Registrar traducciones
    this._i18nService.registerTranslations('es', NAVIGATION_BAR_TRANSLATIONS.es);
    this._i18nService.registerTranslations('en', NAVIGATION_BAR_TRANSLATIONS.en);

    this.currentUserRole.set(this._usersService.role_value as UserRole);
    this.initUserOptions();
    this.initExtraOptionsByRole();
  }

  initUserOptions(): void {
    this.options = [
      {
        label: this.t('nav.user.profile'),
        icon: 'pi pi-user',
        command: () => this.goToProfile(),
      },
      {
        label: this.t('nav.user.logout'),
        icon: 'pi pi-sign-out',
        command: () => this._authService.logout(),
      },
    ]
  }

  private initExtraOptionsByRole(): void {
    const role = this.currentUserRole();

    if (role === UserRole.admin) {
      this.itemsOptions = [
        {
          label: this.t('nav.moreOptions'),
          items: [
            {
              label: this.t('nav.reports'),
              icon: 'pi pi-chart-bar',
              command: () => this.router.navigate(['/admin/report']),
            },
            {
              label: this.t('nav.projects'),
              icon: 'pi pi-folder',
              command: () => this.router.navigate(['/admin/projects']),
            },
            {
              label: this.t('nav.templates'),
              icon: 'pi pi-file',
              command: () => this.router.navigate(['/admin/templates']),
            },
          ],
        },
      ];
    } else {
      this.itemsOptions = [];
    }
  }

  get isHome():boolean{
    return this.router.url.includes('dashboard');
  }
  get isForm():boolean{
    return this.router.url.includes('forms');
  }

  show(event: Event) {
    this.Popover.toggle(event);
    if (this.Popover.overlayVisible) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  // Helper method para traducciones
  public t(key: string): string {
    return this._i18nService.translate(key);
  }

  // Obtener el logo correcto según el idioma actual
  public getLogoPath(): string {
    const currentLanguage = this._i18nService.currentLanguage();

    if (currentLanguage === 'en') {
      return '../../../../assets/images/brand/logo-eng-nav.svg';
    } else {
      // Por defecto español
      return '../../../../assets/images/brand/navbar_logo.svg';
    }
  }
}
type Routes = 'home' | 'templates' | 'institutions' | 'users' | 'projects' | 'report';
